import { isUndefined, pick } from 'lodash';

import { LOCAL_STORAGE_KEY } from '../constants';

type FeatureFlags = {
    FEATURE_FLAGS_ADMIN: boolean;
    FEATURE_FLAGS_CREATORS_DIRECTORY: boolean;
    FEATURE_FLAGS: boolean;
    DESCRIPTION_TESTER: boolean;
    COMMUNITY_BLOG_PAGE: boolean;
    FCRM_LINK_SUFFIX: boolean;
    ROUTER_DEBUGGER_CONSOLE_LOG: boolean;
};

const localStorageFlags = getFlagsFromLocalStorage();

function getFlagsFromLocalStorage(): FeatureFlags {
    let lStorage;
    try {
        lStorage = localStorage.getItem(LOCAL_STORAGE_KEY)
            ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}')
            : {};
    } catch (e) {
        lStorage = {};
    }

    return lStorage;
}

function getFlagState(envVar: keyof FeatureFlags): boolean {
    if (process.env[`REACT_APP_${envVar}`] !== 'true') {
        // prettier-ignore
        console.log('  -- ::: No Feature Flags loaded for ', envVar, ' ::: --');
    }

    if (process.env['REACT_APP_FEATURE_FLAGS'] !== 'true' && !localStorageFlags[envVar]) {
        return false;
    }
    if (!isUndefined(localStorageFlags[envVar])) {
        return localStorageFlags[envVar];
    }
    if (!isUndefined(process.env[`REACT_APP_${envVar}`])) {
        return process.env[`REACT_APP_${envVar}`] === 'true';
    }
    return false;
}

const featureFlags = {
    FEATURE_FLAGS: false,
    FEATURE_FLAGS_ADMIN: false,
    FEATURE_FLAGS_CREATORS_DIRECTORY: false,
    DESCRIPTION_TESTER: false,
    COMMUNITY_BLOG_PAGE: false,
    FCRM_LINK_SUFFIX: false,
    ROUTER_DEBUGGER_CONSOLE_LOG: false,
} as Record<keyof FeatureFlags, boolean>;

(function () {
    Object.keys(featureFlags).map(
        (ff) => (featureFlags[ff as keyof FeatureFlags] = getFlagState(ff as keyof FeatureFlags))
    );

    // Clean out old Flags
    const currentFlags = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    localStorage.setItem(
        LOCAL_STORAGE_KEY,
        JSON.stringify(pick(currentFlags, Object.keys(featureFlags)))
    );
})();

export type ProtectedFeature = keyof FeatureFlags;

export { LOCAL_STORAGE_KEY, getFlagsFromLocalStorage, featureFlags };
